function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.11997 4.60901C2.9372 6.58828 2.45457 10.0825 4.98835 10.9152C6.70252 11.4785 9.63201 10.6599 8.3403 8.41098C7.88351 7.66941 6.97236 6.97655 5.6508 7.77123C3.2976 9.18624 4.16523 11.6195 5.8609 13.2366C7.20957 14.5227 8.86002 14.8794 10.7091 14.9365C11.4955 14.9608 13.5517 14.5314 13.5855 13.2061C13.2672 11.84 12.3407 11.3577 10.8126 12.2769C9.93416 13.144 9.98377 13.9026 10.4592 14.7354C12.7964 18.8292 17.8486 18.5077 21.9467 18.2632",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLooping(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "kraft kraft-looping",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooping);
export default __webpack_public_path__ + "static/media/looping.769d739f.svg";
export { ForwardRef as ReactComponent };